export default "__VITE_ASSET__CuVQlYny__"